import React, { useEffect } from 'react';
import { Snackbar, Alert, CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { hideMessage, selectMessage, isMessageOpen } from 'store/messageSlice';

const Message = () => {
    const dispatch = useDispatch();
    const messageDetails = useSelector(selectMessage);
    const messageOpen = useSelector(isMessageOpen);

    useEffect(() => {
        // Only auto-hide if the message is not a loading message.
        if (messageDetails && messageOpen && !messageDetails.loading) {
            const timer = setTimeout(() => {
                dispatch(hideMessage());
            }, messageDetails.autoHideDuration || 2000);
            return () => clearTimeout(timer);
        }
    }, [dispatch, messageDetails, messageOpen]);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        dispatch(hideMessage());
    };

    return messageDetails ? (
        <Snackbar
            open={messageOpen}
            autoHideDuration={messageDetails.autoHideDuration}
            onClose={handleClose}
            anchorOrigin={messageDetails.anchorOrigin}
        >
            <Alert
                onClose={handleClose}
                severity={messageDetails.variant || 'info'}
                // If loading is true, show a circular progress icon at the start
                icon={messageDetails.loading ? <CircularProgress size={20} style={{ color: 'white' }} /> : undefined}
                sx={{
                    width: '100%',
                    backgroundColor: messageDetails.loading ? '#003476' :
                        messageDetails.variant === 'error' ? '#b71c1c' :
                            messageDetails.variant === 'warning' ? '#ffb300' :
                                messageDetails.variant === 'success' ? '#4e9a51' : '#2f2f31',
                    color: 'white',
                    '& .MuiAlert-icon': {
                        color: 'white !important',
                    },
                }}
            >
                <strong>{messageDetails.message}</strong>
            </Alert>
        </Snackbar>
    ) : null;
};

export default Message;
